export enum ToolState {
  idle,
  drawing,
  editing,
  panning,
  zooming,
}
